import { nameOf } from '../../app/shared/common';
import IProductLookupRedirectPageQuery from './IProductLookupRedirectPageQuery';

export const SKU = nameOf<IProductLookupRedirectPageQuery>('sku');
export const CODE: string = nameOf<IProductLookupRedirectPageQuery>('code');
